export default class Searchbar {
    static container
    static button
    static openClass = 'search-open'
    static input
    static isOpen = false
    static closeButton

    static init() {
        this.setFields()

        if (!this.button) {
            return
        }

        this.bindEvents()
    }

    static setFields() {
        this.container = document.querySelector('[data-searchbar]')
        this.button = Array.from(document.querySelectorAll('[data-searchbar-button]'))
            .filter(el => getComputedStyle(el).display !== 'none')[0]
        this.input = document.querySelector('[data-searchbar-input]')
        this.closeButton = document.querySelector('[data-searchbar-close]')
    }

    static bindEvents() {
        this.button.addEventListener('click', this.toggle.bind(this))
        this.container.addEventListener('click', this.handleOutsideClick.bind(this))
        this.closeButton.addEventListener('click', this.close.bind(this))
        document.addEventListener('keydown', this.handleKeyEvents.bind(this))
    }

    static toggle() {
        this.isOpen = !this.isOpen
        document.documentElement.classList.toggle(this.openClass)
        this.button.setAttribute('aria-expanded', this.isOpen)

        if (this.isOpen) {
            this.input.focus()
        }

        document.addEventListener('keydown', this.preventTab.bind(this))
    }

    static close() {
        this.isOpen = false
        document.documentElement.classList.remove(this.openClass)
        this.button.setAttribute('aria-expanded', this.isOpen)
    }

    static handleKeyEvents(e) {
        if (e.key === 'Escape') this.close()

        if (e.key === 'k' && (e.ctrlKey || e.metaKey)) {
            e.preventDefault()
            this.toggle()
        }
    }

    static handleOutsideClick(e) {
        if (e.target === this.container) this.toggle()
    }

    static preventTab(e) {
        if (e.keyCode === 9 && this.isOpen) {
            e.preventDefault()
        }
    }
}
